import React, { useEffect, useRef } from "react";
import { useState } from "react";
import { AnimatePresence } from "framer-motion";
import CardHeadMenu from "../../../Components/Card/CardHeadMenu/CardHeadMenu";
import CouponsForm from "./CouponsForm";
import { useSelector } from "react-redux";
import configServ from "../../../services/config";
import CouponsTable from "./CouponsTable";
import debounce from "lodash.debounce";
import { useCallback } from "react";
const CouponsCard = () => {
  const { company_id, user_id } = useSelector((state) => state.GlobalVariables);

  const [isCreate, setIsCreate] = useState(false);
  const [couponsData, setCouponsData] = useState([]);
  const [loading, SetLoading] = useState(true);
  const [searchBy, setSearchBy] = useState("coupon_name");
  const [search, setSearch] = useState("");
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(10);
  const [total, setTotal] = useState(0);
  const [editCouponData, setEditCouponData] = useState(null); // stores the data for editing
  const [isEdit, setIsEdit] = useState(false);
  const fetchCoupons = async () => {
    try {
      SetLoading(true);
      const payload = {
        company_id: company_id,
        search_by: searchBy,
        search,
        page: page + 1,
        per_page: perPage,
      };
      const res = await configServ.getAllCouponsWithItems(payload);
      if (res.status) {
        setCouponsData(res.data);
        setTotal(res.total);
      }
    } catch (error) {
      console.error("Failed to fetch coupons", error);
    } finally {
      SetLoading(false);
    }
  };

  const firstSearchLoad = useRef(true); // to prevent double fetch

  useEffect(() => {
    if (firstSearchLoad.current) {
      firstSearchLoad.current = false;
      return; // skip first auto-fetch here
    }

    setPage(0); // ✅ reset page if search/searchBy changes
  }, [search, searchBy]);

  const debouncedFetch = useCallback(
    debounce(() => {
      fetchCoupons();
    }, 500),
    [search, searchBy, page, perPage]
  );

  useEffect(() => {
    debouncedFetch();
    return debouncedFetch.cancel;
  }, [search, searchBy, page, perPage]);

  const handlePopup = () => {
    try {
      setIsCreate(!isCreate);
      setEditCouponData(null)
      setIsEdit(false)
    } catch (e) {
      console.log(e);
    }
  };
  const scrollUp = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };
  
  const handleEdit = (coupon) => {
    setEditCouponData(coupon); // Save the data
    setIsCreate(true); // Open the form
    setIsEdit(true)
    scrollUp();
  };

  return (
    <>
      <CardHeadMenu
        prefix={"Na"}
        suffix={"Na"}
        title={"Create Coupons"}
        handlePopup={handlePopup}
        // isEdit={isEdit}
        create={isCreate}
        // showCreate={Boolean(is_super || is_admin || permissions?.includes(25))}
      />
      <AnimatePresence>
        {isCreate === true && (
          <CouponsForm
            isCreate={isCreate}
            setIsCreate={setIsCreate}
            onSuccess={fetchCoupons}
            editData={editCouponData}
            isEdit={isEdit}
            setEditCouponData={setEditCouponData}
            setIsEdit={setIsEdit}
          />
        )}
      </AnimatePresence>
      <CouponsTable
        couponsData={couponsData}
        loading={loading}
        searchBy={searchBy}
        search={search}
        page={page}
        perPage={perPage}
        total={total}
        setCouponsData={setCouponsData}
        SetLoading={SetLoading}
        setSearchBy={setSearchBy}
        setSearch={setSearch}
        setPage={setPage}
        setPerPage={setPerPage}
        setTotal={setTotal}
        handleEdit={handleEdit}
      />
    </>
  );
};

export default CouponsCard;
